import React from 'react'
import Header from './header'
import SideMenu from './side_menu/side_menu'
import DashboardLink from './side_menu/dashboard_link'

interface LayoutProps {
  children: React.ReactNode
}

const AuthenticatedLayout: React.FC<LayoutProps> = (props) => {
  return (
    <div className="w-screen flex min-h-screen">
      <div>
        <SideMenu
          items={[
            {
              label: 'ホーム',
              icon: 'home',
              path: '/dashboard',
              children: [],
            },
            {
              label: '事業アイデア',
              icon: 'lightbulb',
              path: null,
              children: [
                {
                  label: 'マイアイデア',
                  path: '/myidea',
                },
              ],
            },
            {
              label: '企業',
              icon: 'business',
              path: null,
              children: [
                {
                  label: 'お気に入り企業一覧',
                  path: '/enterprises/favorite',
                },
                {
                  label: 'マッチング企業一覧',
                  path: '/enterprises/matching',
                },
                {
                  label: '企業詳細検索',
                  path: '/enterprises/search',
                },
              ],
            },
            {
              label: '足跡',
              icon: 'history',
              path: null,
              children: [
                {
                  label: '足跡一覧',
                  path: '/asiato',
                },
              ],
            },
            {
              label: '共創パートナー募集',
              icon: 'handshake',
              path: null,
              children: [
                {
                  label: '共創パートナー募集一覧',
                  path: '/recruitment',
                },
                {
                  label: '自社の募集',
                  path: '/recruitment/manage',
                },
              ],
            },
            {
              label: 'チャット',
              icon: 'chat',
              path: null,
              children: [
                {
                  label: 'チャットページ',
                  path: '/chat',
                },
              ],
            },
            {
              label: 'サービス連携',
              icon: 'link',
              path: null,
              children: [
                {
                  label: 'ダッシュボード',
                  component: (
                    <DashboardLink>
                      <div className="cursor-pointer hover:opacity-50 transition-opacity duration-300">
                        ダッシュボード
                      </div>
                    </DashboardLink>
                  ),
                },
              ],
            },
          ]}
        />
      </div>
      <div className="w-full">
        <Header />
        <div className="w-11/12 mx-auto">{props.children}</div>
      </div>
    </div>
  )
}

export default AuthenticatedLayout
